import { render, staticRenderFns } from "./LanguagesMultiselect.vue?vue&type=template&id=b9129ade&scoped=true&"
import script from "./LanguagesMultiselect.vue?vue&type=script&lang=js&"
export * from "./LanguagesMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9129ade",
  null
  
)

export default component.exports